import ProductCombinationCard from "@components/Cards/ProductCombinationCard"
import RelatedCombinationCard from "@components/Cards/RelatedCombinationCard"
import { ProductCombinationGrid } from "@components/Cards/RelatedCombinationCard/elements"
import { NormalizedRelatedCombination } from "@lib/hooks/helpers/get-normalized-related-combinations"
import { CalloutCardCollectionDetailPage } from "@lib/kontent/models/CalloutCardCollectionDetailPage"
import * as qs from "query-string"
import React from "react"
import { FilterState } from "."
import { CalloutCard } from "./CalloutCard"

const loadingItems = Array.from(Array(6)).map((u, i) => (
  <ProductCombinationCard key={`loading-${i}`} isLoading href="" />
))

interface Props {
  loading: boolean
  fetchingMore: boolean
  items: NormalizedRelatedCombination[]
  prefix: string
  callOutCards: CalloutCardCollectionDetailPage[]
  filters: FilterState
}

const Grid: React.FC<Props> = ({
  loading,
  fetchingMore,
  prefix,
  items,
  callOutCards,
  filters,
}) => {
  const firstCard = callOutCards[0] && callOutCards[0]
  const secondCard = callOutCards[1] && callOutCards[1]
  let args = {
    style: filters.style,
  }

  const filterParams = encodeURIComponent(qs.stringify(args))

  return (
    <ProductCombinationGrid data-testid="ac-grid">
      {loading && !fetchingMore ? (
        loadingItems
      ) : (
        <>
          {items.map((item, index) => {
            const card = (
              <RelatedCombinationCard
                key={item.id}
                relatedCombinationId={item.id}
                prefix={prefix}
                suffix={`?overview_filters=${filterParams}`}
                {...item}
              />
            )
            return index === 5 && firstCard ? (
              <CalloutCard key={index} {...firstCard} />
            ) : index === 9 && secondCard ? (
              <CalloutCard key={index} {...secondCard} />
            ) : (
              card
            )
          })}
          {fetchingMore && loadingItems}
        </>
      )}
    </ProductCombinationGrid>
  )
}

export default Grid
